import React from 'react'
import { useForm } from "react-hook-form"
import styles from './loginForm.module.css';
import { Button } from "../../ui/button/Button"
import { useMutation } from '@tanstack/react-query';
import { authApi } from '../../../api/authMutation/authApi';
import { useUserStore } from '../../../stores/useUserStore';
import { useNavigate } from 'react-router';
export function LoginForm() {
    const { user, setCredentials } = useUserStore();
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
    } = useForm();

    const { mutate, error, data } = useMutation({
        mutationFn: (loginData) => {
            return authApi.login(loginData);
        },
        onSuccess: (data) => {
            const username = watch('username');


            setCredentials({ token: data.data.access_token, username })
            navigate('/');
        },
    });





    const onSubmit = (data) => {
        mutate(data);
    };

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
                <div className={styles.formHeader}>Вход</div>
                <div className={styles.formGroup}>
                    <div >
                        <div className={styles.input_wrapper}>
                            <input
                                placeholder='Имя'
                                className={`${styles.input} ${errors.username && styles.errorInput}`}
                                {...register("username", { required: "Это поле обязательно", })}
                            />
                            {(errors.username || error) && (
                                <span className={styles.error}>
                                    {errors.username?.message || error?.message || "Непредвиденная ошибка"}
                                </span>
                            )}
                        </div>
                    </div>
                    <div >

                        <input
                            className={`${styles.input} ${errors.password && styles.errorInput}`}
                            placeholder='Пароль'
                            {...register("password", {
                                required: "Это поле обязательно",
                                minLength: { value: 8, message: "Пароль должен быть не менее 8 символов" }

                            })}
                            type="password"
                        />
                        {(errors.password || error) && (
                            <span className={styles.error}>
                                {errors.password?.message || error?.message || "Непредвиденная ошибка"}
                            </span>
                        )}
                    </div>

                </div>

                <Button type='submit' variant={"dark-blue"} >
                    Войти
                </Button>
            </form>
            <Button width={"w-455"} variant={"dark-blue"} onClick={() => navigate('/signUp')}  >Нет аккаунта?</Button>
        </div>
    );
}
